import axiosClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callSectionContentMasterGetApi = async (payload) => {
  const { data = {} } = await axiosClient.get(API.sectionContentMaster,{
    params:{
      customerSegmentIds:payload?.customerSegmentId
  }
});
  return data;
};